import {
    ADD_ITEM_COMMUNICATION_REQUEST,
    ADD_ITEM_COMMUNICATION_SUCCESS,
    ADD_ITEM_COMMUNICATION_ERROR,
    GET_ITEM_COMMUNICATION_REQUEST,
    GET_ITEM_COMMUNICATION_SUCCESS,
    GET_ITEM_COMMUNICATION_ERROR,
    DELETE_ITEM_COMMUNICATION_REQUEST,
    DELETE_ITEM_COMMUNICATION_SUCCESS,
    DELETE_ITEM_COMMUNICATION_ERROR,

} from "../actions/types"

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case ADD_ITEM_COMMUNICATION_REQUEST:
            return {
                loading: true,
            };
        case ADD_ITEM_COMMUNICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case ADD_ITEM_COMMUNICATION_ERROR:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_ITEM_COMMUNICATION_REQUEST:
            return {
                loading: true,
            };
        case GET_ITEM_COMMUNICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ITEM_COMMUNICATION_ERROR:
            return {
                ...state,
                loading: false,
                payload
            };
        case DELETE_ITEM_COMMUNICATION_REQUEST:
            return {
                loading: true,
            };
        case DELETE_ITEM_COMMUNICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case DELETE_ITEM_COMMUNICATION_ERROR:
            return {
                ...state,
                loading: false,
                payload
            };

        default:
            return state;
    }
}